import { Header } from '@/pages/campaign/ListPage/components/Header';
import styled from '@emotion/styled';
import { CampaignsLibrary } from './components/Library';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const CampaignPage = () => {
    return (
        <Container>
            <Header />
            <CampaignsLibrary />
        </Container>
    );
};
